import {
  getCookies,
  removeCookies,
} from "../common/cookiesHelper/CookiesUtills";
import { CookiesItemEnum } from "../enums/CookiesItemEnum";
import {
  affiliatesUtmGroup,
  GoogleUtmGroup,
  partnerAffiliatesUtmGroup,
  UtmChanelEnum,
} from "../enums/UtmChanelEnum";

export const checkIsMobileApp = (utmid: string): boolean => {
  return (
    utmid === UtmChanelEnum.GOTHER_APP_ANDROID ||
    utmid === UtmChanelEnum.GOTHER_APP_IOS
  );
};
export const isUtmAffiliate = (utmId: string) => {
  return affiliatesUtmGroup.includes(`${utmId}` as UtmChanelEnum);
};

export const isPartnerAffiliatesUtmGroup = (utmId: string) => {
  return partnerAffiliatesUtmGroup.includes(utmId as UtmChanelEnum);
};

export const isUtmGoogle = (utmId: string) => {
  return GoogleUtmGroup.includes(`${utmId}` as UtmChanelEnum);
};
export const removeUtmGoogle = () => {
  const utmId = getCookies(CookiesItemEnum.COOKIE_UTM_ID);
  if (utmId && isUtmGoogle(utmId)) {
    removeCookies(CookiesItemEnum.COOKIE_UTM_ID);
  }
};

const env = process.env.NODE_ENV?.toLowerCase();

export const isProduction = env === "production" || env === "pre-prod";

export const isDevelopment =
  env === "development" || env === "local" || env === "staging";
